// 关键词变化
export const SEARCHING_CHANGE_KEYWORD = 'SEARCHING_CHANGE_KEYWORD';


// WEBPACK FOOTER //
// ./src/pages/search/store/types.js